import { LOCALES, KEYS } from '../constants';

const ptPTTranslations = Object.freeze({
  [LOCALES.L18N_LOCALE_PORTUGUESE_PT] : {
    [KEYS.L18N_KEY_LABEL_PARTNER_ROLE]: "Função de parceiro",
    [KEYS.L18N_KEY_LABEL_INTEGRATOR]: "Integrador",
    [KEYS.L18N_KEY_LABEL_PROVIDER]: "Fornecedor",
    [KEYS.L18N_KEY_LABEL_PARTNER_LEVEL]: "Nível do parceiro",
    [KEYS.L18N_KEY_LABEL_PARTNER_SPECIALIZATION]: "Especialização do parceiro",
    [KEYS.L18N_KEY_LABEL_CISCO_POWERED_SERVICE]: " Serviço Cisco Powered",
    [KEYS.L18N_KEY_LABEL_PARTNER_NAME]: "Nome do Parceiro",
    [KEYS.L18N_KEY_LABEL_LOCATION]: "Localização",
    [KEYS.L18N_KEY_LABEL_COUNTRY]: "País",
    [KEYS.L18N_KEY_LABEL_PARTNER_NAME_KEYWORD]: "Palavra-chave do nome do parceiro",
    [KEYS.L18N_KEY_LABEL_PARTNER_NAME_KEYWORD_S_]: "Palavra(s)-chave do nome do parceiro",
    [KEYS.L18N_KEY_LABEL_SORTING]: "Ordenação",
    [KEYS.L18N_KEY_LABEL_SPECIALIZATIONS]: "Especializações",
    [KEYS.L18N_KEY_LABEL_PARTNER_SPECIALIZATIONS]: "Especializações de parceiros",
    [KEYS.L18N_KEY_LABEL_PROVIDER_LEVEL_AND_CISCO_POWERED_SERVICES]: "Serviços Cisco Powered e nível do fornecedor",
    [KEYS.L18N_KEY_LABEL_GOLD_PROVIDER]: "fornecedor Gold",
    [KEYS.L18N_KEY_LABEL_PREMIER_PROVIDER]: "fornecedor Premier",
    [KEYS.L18N_KEY_LABEL_SELECT_PROVIDER]: "selecionar fornecedor",
    [KEYS.L18N_KEY_LABEL_ELOQUA__GET_GUIDANCE]: "Obter orientação",
    [KEYS.L18N_KEY_LABEL_ELOQUA__REQUEST_A_QUOTE]: "Solicitar um orçamento",
    [KEYS.L18N_KEY_LABEL_OPEN]: "Aberto",
    [KEYS.L18N_KEY_LABEL_EXPAND]: "Expandir",
    [KEYS.L18N_KEY_LABEL_COLLAPSE]: "Reduzir",
    [KEYS.L18N_KEY_LABEL_CHOOSE_A_COUNTRY]: "Escolher um país/região",
    [KEYS.L18N_KEY_LABEL_CHOOSE_A_ROLE]: "Escolher uma função",
    [KEYS.L18N_KEY_LABEL_CHOOSE_SPECIALIZATION_S_]: "Escolher especialização(ões)",
    [KEYS.L18N_KEY_LABEL_CHOOSE_CISCO_POWERED_SERVICE_S_]: "Escolher Serviço(s) Cisco Powered",
    [KEYS.L18N_KEY_LABEL_CHOOSE_EXPERTISE_S]: "Escolher conhecimento(s)",
    [KEYS.L18N_KEY_LABEL_CHOOSE_LEVEL_S_]: "Escolher nível(eis)",
    [KEYS.L18N_KEY_LABEL_PARTNER_COUNTRY]: "País/região do parceiro",
    [KEYS.L18N_KEY_LABEL_INTEGRATOR_LEVELS]: "Níveis do integrador",
    [KEYS.L18N_KEY_LABEL_PROVIDER_LEVELS]: "Níveis do fornecedor",
    [KEYS.L18N_KEY_LABEL_INTEGRATOR_SPECIALIZATIONS]: "Especializações do integrador",
    [KEYS.L18N_KEY_LABEL_CISCO_POWERED_SERVICES]: "Serviços Cisco Powered",
    [KEYS.L18N_KEY_LABEL_PARTNER_NAMES]: "Nomes do parceiro",
    [KEYS.L18N_KEY_LABEL_BACK]: "Voltar",
    [KEYS.L18N_KEY_LABEL_ALL_RESULTS]: "Todos os resultados",
    [KEYS.L18N_KEY_LABEL_ALL]: "All (Tudo)",
    [KEYS.L18N_KEY_LABEL_SAVED]: "Guardadas",
    [KEYS.L18N_KEY_LABEL_MY_PARTNERS]: "Os meus parceiros",
    [KEYS.L18N_KEY_LABEL_ADD]: "Adicionar",
    [KEYS.L18N_KEY_LABEL_REMOVE]: "Remover",
    [KEYS.L18N_KEY_LABEL_ADD_TO_COMPARE]: "Adicionar para comparar",
    [KEYS.L18N_KEY_LABEL_SELECT_AT_LEAST_ONE_MORE]: "Selecionar, pelo menos, mais um",
    [KEYS.L18N_KEY_LABEL_COMPARE_SELECTED]: "Comparar selecionados",
    [KEYS.L18N_KEY_LABEL_REMOVE_FROM_COMPARATOR]: "Remover do comparador",
    [KEYS.L18N_KEY_LABEL_COMPARE]: "Comparar",
    [KEYS.L18N_KEY_LABEL_PARTNER_LEVEL]: "Nível do parceiro",
    [KEYS.L18N_KEY_LABEL_PROCESSING_IN_PROGRESS]: "Processamento em curso",
    [KEYS.L18N_KEY_LABEL_RESULT]: "resultado",
    [KEYS.L18N_KEY_LABEL_RESULTS]: "resultados",
    [KEYS.L18N_KEY_LABEL_NO_RESULTS]: "Nenhum resultado",
    [KEYS.L18N_KEY_LABEL_RESULT_IN]: "resultado em",
    [KEYS.L18N_KEY_LABEL_RESULTS_IN]: "resultados em",
    [KEYS.L18N_KEY_LABEL_NO_RESULTS_IN]: "Nenhum resultado em",
    [KEYS.L18N_KEY_LABEL_PREVIOUS]: "Anterior",
    [KEYS.L18N_KEY_LABEL_PREV]: "Ant.",
    [KEYS.L18N_KEY_LABEL_NEXT]: "Seguinte",
    [KEYS.L18N_KEY_LABEL_SAVE]: "Guardar",
    [KEYS.L18N_KEY_LABEL_EXPERTISE]: "Conhecimento",
    [KEYS.L18N_KEY_LABEL_OVERVIEW]: "Descrição geral",
    [KEYS.L18N_KEY_LABEL_IS_A_CISCO]: "é um Cisco",
    [KEYS.L18N_KEY_LABEL_ROLE_INTEGRATOR_DESCRIPTION]: "Os integradores criam soluções end-to-end para os nossos clientes. Transacionam principalmente num movimento de revenda, mas trazem os seus próprios conhecimentos únicos para resolver problemas empresariais",
    [KEYS.L18N_KEY_LABEL_ROLE_PROVIDER_DESCRIPTION]: "Os fornecedores são especialistas em fornecer soluções na cloud e geridas. Os clientes estão à procura de uma maior flexibilidade na forma como consomem soluções e os fornecedores estão a tornar-se cada vez mais importantes no mercado.",
    [KEYS.L18N_KEY_LABEL_PAST_SEARCHES]: "Pesquisas anteriores",
    [KEYS.L18N_KEY_LABEL_PAST_SEARCH]: "Pesquisa anterior",
    [KEYS.L18N_KEY_LABEL_ROLES]: "Funções",
    [KEYS.L18N_KEY_LABEL_TECHNOLOGY]: "Tecnologia",
    [KEYS.L18N_KEY_LABEL_INDUSTRIES]: "Indústrias",
    [KEYS.L18N_KEY_LABEL_INTEGRATORS]: "Integradores",
    [KEYS.L18N_KEY_LABEL_PROVIDERS]: "Fornecedores",
    [KEYS.L18N_KEY_LABEL_OTHER]: "Outro",
    [KEYS.L18N_KEY_LABEL_OTHERS]: "Outros",
    [KEYS.L18N_KEY_LABEL_NO_SAVED_OTHER_PARTNERS]: "Mais nenhum parceiro guardado",
    [KEYS.L18N_KEY_LABEL_NO_SAVED_INTEGRATORS]: "Nenhum integrador guardado",
    [KEYS.L18N_KEY_LABEL_NO_SAVED_PROVIDERS]: "Nenhum fornecedor guardado",
    [KEYS.L18N_KEY_LABEL_FILTER_BY_NEED]: "filtrar por necessidade",
    [KEYS.L18N_KEY_LABEL_SEARCH_BY_COMBINED_CRITERIA]: "pesquisar por critérios combinados",
    [KEYS.L18N_KEY_LABEL_SEARCH_BY_LOCATION]: "pesquisar por localização",
    [KEYS.L18N_KEY_LABEL_THERE_IS_ONE_PARTNER_SERVING_WORLDWIDE]: "Há 1 parceiro a fornecer a nível mundial",
    [KEYS.L18N_KEY_LABEL_THERE_ARE]: "Há",
    [KEYS.L18N_KEY_LABEL_PARTNERS_SERVING_WORLDWIDE]: "parceiros a fornecer a nível mundial",
    [KEYS.L18N_KEY_LABEL_THERE_ARE_ONE_NO_PARTNERS_SERVING]: "Não há parceiros a fornecer",
    [KEYS.L18N_KEY_LABEL_THERE_IS_ONE_PARTNER_SERVING_IN]: "Há 1 parceiro a fornecer em",
    [KEYS.L18N_KEY_LABEL_PARTNERS_SERVING_IN]: "parceiros a fornecer em",
    [KEYS.L18N_KEY_LABEL_THERE_ARE_ONE_PARTNERS_SERVING_IN]: "Não há parceiros a fornecer em",
    [KEYS.L18N_KEY_LABEL_CHANGE_LOCATION]: "Alterar localização",
    [KEYS.L18N_KEY_LABEL_FILTER_BY_NEED]: "Filtrar por necessidade",
    [KEYS.L18N_KEY_LABEL_SEARCH]: "Pesquisar",
    [KEYS.L18N_KEY_LABEL_BY_NAME_ONE_LEVEL_AND_EXPERTISE]: "por nome, nível e conhecimento",
    [KEYS.L18N_KEY_LABEL_SELECTED]: " selecionado",
    [KEYS.L18N_KEY_LABEL_NO_MATCHES_FOUND]: "Nenhuma correspondência encontrada",
    [KEYS.L18N_KEY_LABEL_RANK_UP]: "Classificação acima",
    [KEYS.L18N_KEY_LABEL_RANK_DOWN]: "Classificação abaixo",
    [KEYS.L18N_KEY_LABEL_NAME_UP]: "Nome acima",
    [KEYS.L18N_KEY_LABEL_NAME_DOWN]: "Nome abaixo",
    [KEYS.L18N_KEY_LABEL_LOGIN_REQUIRED]: "Início de sessão necessário",
    [KEYS.L18N_KEY_LABEL_YOU_MUST_ONE_PERFORM_THIS_ACTION]: "Tem de iniciar sessão para realizar esta ação",
    [KEYS.L18N_KEY_LABEL_SEARCH_RESTORATION_FAILED]: "Falha ao restaurar a pesquisa",
    [KEYS.L18N_KEY_LABEL_LOG_IN]: "Iniciar sessão",
    [KEYS.L18N_KEY_LABEL_PARTNER_SUCCESSFULLY_SAVED]: "Parceiro guardado com êxito",
    [KEYS.L18N_KEY_LABEL_THE_PARTNER_ONE_NOT_BE_SAVED]: "Não foi possível guardar o parceiro",
    [KEYS.L18N_KEY_LABEL_PARTNER_SUCCESSFULLY_REMOVED]: "Parceiro removido com êxito",
    [KEYS.L18N_KEY_LABEL_THE_PARTNER_ONE_NOT_BE_DELETED]: "Não foi possível eliminar o parceiro",
    [KEYS.L18N_KEY_LABEL_TYPE_A_ONE_LEVEL_OR_EXPERTISE]: "Introduza uma palavra-chave para pesquisar por nome, nível ou conhecimento",
    [KEYS.L18N_KEY_LABEL_ROLE_DEVELOPER_DESCRIPTION]: "Os programadores são especialistas que criam soluções de software e hardware personalizadas com base na tecnologia da Cisco, o que resulta em soluções únicas que combinam sistemas para fornecer resultados.",
    [KEYS.L18N_KEY_LABEL_ROLE_ADVISOR_DESCRIPTION]: "Os consultores são especialistas com conhecimentos aprofundados sobre o setor, que orientam as empresas à medida que exploram soluções para desafios empresariais complexos.​",
    [KEYS.L18N_KEY_LABEL_DIVERSE_PARTNER]: "Parceiro diversificado",
    [KEYS.L18N_KEY_LABEL_ALPHABETICAL]: "Alfabética",
    [KEYS.L18N_KEY_LABEL_MOST_EXPERTISE]: "Com mais conhecimentos",
    [KEYS.L18N_KEY_LABEL_DEVELOPER]: "Programador",
    [KEYS.L18N_KEY_LABEL_ADVISOR]: "Consultor",

    [KEYS.L18N_KEY_LABEL_FILTERS]:"Filtros",
    [KEYS.L18N_KEY_LABEL_FILTER_VERB]:"Filtro",
    [KEYS.L18N_KEY_LABEL_PARTNER_EXPERTISE]:"Conhecimento do parceiro",
    [KEYS.L18N_KEY_LABEL_DISMISS_VERB]:"Dispensar",
    [KEYS.L18N_KEY_LABEL_SPECIALIZATION]:"Especialização",
    [KEYS.L18N_KEY_LABEL_EXPERTISES]:"Conhecimentos",
    [KEYS.L18N_KEY_LABEL_NO_DESCRIPTION_PROVIDED_DOT]:"Nenhuma descrição fornecida.",
    [KEYS.L18N_KEY_LABEL_ABOUT]:"Acerca de",
    [KEYS.L18N_KEY_LABEL_CLEAR_COMPARATOR]:"Limpar comparador",
    [KEYS.L18N_KEY_LABEL_PARTNER_COMPARISON]:"Comparação de parceiros",
    [KEYS.L18N_KEY_LABEL_ROLE]:"Função",
    [KEYS.L18N_KEY_LABEL_TECHNOLOGICAL_FOCUS]:"Foco tecnológico",
    [KEYS.L18N_KEY_LABEL_DESCRIPTION]:"Descrição",
    [KEYS.L18N_KEY_LABEL_CHOOSE_LANGUAGE_SELECTION]:"Escolher seleção de idioma",
    [KEYS.L18N_KEY_LABEL_LOG_OUT]:"Terminar sessão",
    [KEYS.L18N_KEY_LABEL_INCLUSIVE_PARTNER]:"Parceiro inclusivo",

    [KEYS.L18N_KEY_LABEL_ABOUT_CISCO]: "Sobre a Cisco",
    [KEYS.L18N_KEY_LABEL_CONTACT_US]: "Fale conosco",
    [KEYS.L18N_KEY_LABEL_CAREERS]: "Carreiras",
    [KEYS.L18N_KEY_LABEL_MEET_OUR_PARTNERS]: "Conheça nossos parceiros",
    [KEYS.L18N_KEY_LABEL_FEEDBACK]: "Comentários",
    [KEYS.L18N_KEY_LABEL_HELP]: "Ajuda",
    [KEYS.L18N_KEY_LABEL_TERMS_AND_CONDITIONS]: "Termos e Condições",
    [KEYS.L18N_KEY_LABEL_PRIVACY_STATEMENT]: "Declaração de privacidade",
    [KEYS.L18N_KEY_LABEL_COOKIES]: "Cookies",
    [KEYS.L18N_KEY_LABEL_TRADEMARKS]: "Marcas registradas",
    [KEYS.L18N_KEY_LABEL_SUPPLY_CHAIN_TRANSPARENCY]: "Transparência da cadeia de suprimentos",
    [KEYS.L18N_KEY_LABEL_SITEMAP]: "Mapa do site",

    [KEYS.L18N_KEY_LABEL_ABOUT_CISCO]: "Sobre a Cisco",
    [KEYS.L18N_KEY_LABEL_CONTACT_US]: "Fale conosco",
    [KEYS.L18N_KEY_LABEL_CAREERS]: "Carreiras",
    [KEYS.L18N_KEY_LABEL_MEET_OUR_PARTNERS]: "Conheça nossos parceiros",
    [KEYS.L18N_KEY_LABEL_FEEDBACK]: "Comentários",
    [KEYS.L18N_KEY_LABEL_HELP]: "Ajuda",
    [KEYS.L18N_KEY_LABEL_TERMS_AND_CONDITIONS]: "Termos e Condições",
    [KEYS.L18N_KEY_LABEL_PRIVACY_STATEMENT]: "Declaração de privacidade",
    [KEYS.L18N_KEY_LABEL_COOKIES]: "Cookies",
    [KEYS.L18N_KEY_LABEL_TRADEMARKS]: "Marcas registradas",
    [KEYS.L18N_KEY_LABEL_SUPPLY_CHAIN_TRANSPARENCY]: "Transparência da cadeia de suprimentos",
    [KEYS.L18N_KEY_LABEL_SITEMAP]: "Mapa do site",
    [KEYS.L18N_KEY_LABEL_HOW_TO_BUY]: "Como comprar",
    [KEYS.L18N_KEY_LABEL_PARTNERS]: "Parceiros",
    [KEYS.L18N_KEY_LABEL_PRODUCTS_AND_SERVICES]: "Produtos e Serviços",
    [KEYS.L18N_KEY_LABEL_SOLUTIONS]: "Soluções",
    [KEYS.L18N_KEY_LABEL_SUPPORT]: "Suporte",
    [KEYS.L18N_KEY_LABEL_LEARN]: "Aprender",
    [KEYS.L18N_KEY_LABEL_EXPLORE_CISCO]: "Explorar Cisco",
    [KEYS.L18N_KEY_LABEL_MENU]: "Menu",
    [KEYS.L18N_KEY_LABEL_CLOSE]: "Fechar",
    [KEYS.L18N_KEY_LABEL_SEE_MORE]: "Ver mais",
    [KEYS.L18N_KEY_LABEL_SEE_LESS]: "Ver menos",
    [KEYS.L18N_KEY_LABEL_DONT_HAVE_AN_ACCOUNT]: "Não tem uma conta?",
    [KEYS.L18N_KEY_LABEL_SIGN_UP]: "inscreva-se"

  }
});

export default ptPTTranslations;
